module.exports = __webpack_public_path__ + "img/Estonia.c5a5b3f8.svg";